import { Error } from "grpc-web";

import { EGrpcErrorCode } from "@/custom-types";

// GRPC error code docs found at: https://github.com/grpc/grpc/blob/master/doc/statuscodes.md

const grpcErrorToMessageMap: { [key: number]: string } = {
  [EGrpcErrorCode.CANCELLED]: "Error: Operation cancelled",
  [EGrpcErrorCode.UNKNOWN]: "Error: Unknown error occurred",
  [EGrpcErrorCode.DEADLINE_EXCEEDED]:
    "Error: Deadline exceeded. Server took too long to respond.",
  [EGrpcErrorCode.NOT_FOUND]:
    "Error: Entity not found. The resource you are looking for does not exist.",
  [EGrpcErrorCode.ALREADY_EXISTS]:
    "Error: Entity already exists. The resource you are trying to create already exists.",
  [EGrpcErrorCode.PERMISSION_DENIED]:
    "Error: Permission denied. You don't have permission to access this resource.",
  [EGrpcErrorCode.RESOURCE_EXHAUSTED]:
    "Error: Resource exhausted. Your quota of something has run out or the file system has run out of space.",
  [EGrpcErrorCode.FAILED_PRECONDITION]:
    "Error: Bad request. The operation you have requested cannot be carried out.",
  [EGrpcErrorCode.ABORTED]: "Error: Operation aborted.",
  [EGrpcErrorCode.OUT_OF_RANGE]:
    "Error: Out of range. Operation attempted past the valid range",
  [EGrpcErrorCode.UNIMPLEMENTED]:
    "Error: Unimplemented. The operation you have requested is not supported or enabled.",
  [EGrpcErrorCode.INTERNAL]: "Error: Internal Error.",
  [EGrpcErrorCode.UNAVAILABLE]:
    "Error: Resource unavailable. Please try again later.",
  [EGrpcErrorCode.DATA_LOSS]: "Error: Data Corrupted.",
  [EGrpcErrorCode.UNAUTHENTICATED]:
    "Error: Invalid credentials. Logging in as guest. If you have an account please try logging in again."
};

const mapGrpcErrorToString = (err: Error): string => {
  // GRPC error code docs found at: https://github.com/grpc/grpc/blob/master/doc/statuscodes.md
  if (err.code === EGrpcErrorCode.INVALID_ARGUMENT) {
    if (err.message.includes("missing token")) {
      return "Error caused by incorrect token. Logging user in as guest.";
    } else {
      return "Error: Call to backend failed due to an invalid argument.";
    }
  }
  return grpcErrorToMessageMap[err.code] || "Error: " + err.message;
};

export default mapGrpcErrorToString;
